<template>
  <div class="form-check">
    <input v-if="value" v-model="inputModel" :id="name"
           :value="value"
           class="form-check-input" type="checkbox"
           :checked="inputModel"
           :disabled="disabled">
    <input v-else v-model="inputModel" :id="name"
           class="form-check-input" type="checkbox"
           :checked="inputModel"
           :disabled="disabled">

    <label v-if="label" :for="name" class="form-check-label">
      <div v-if="icon" class="icon">
        <LucideIcon :icon="icon" />
      </div>
      <div v-if="groupIcon" class="color palette-purple-light"></div>
      {{ label }}
    </label>
  </div>
</template>
<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'CheckboxElement',
  emits: ['update:modelValue', 'onChange'],
  props: {
    name: {
      type: String,
      required: true,
    },
    modelValue: {
      required: true,
    },
    label: {
      type: String,
    },
    value: {
      type: String,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    icon: {
      type: [String, Boolean],
      default: false,
      required: false,
    },
    iconType: {
      type: String,
      default: 'fas',
      required: false,
    },
    groupIcon: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    inputModel: {
      get(): any {
        return this.modelValue;
      },
      set(value: any): void {
        this.$emit('update:modelValue', value);
        this.$emit('onChange', value);
      },
    },
  },
  methods: {},
});
</script>

<style lang="scss" scoped>

.form-check {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  margin-bottom: 0;
  max-height: 16px;
  padding-left: 15px;
}

.form-check-label {
  font-size: var(--fs-14);
  margin-left: var(--space-8);
  color: var(--text-dark);
  width: 100%;
  cursor: pointer;
  display: inline-block;
  gap: var(--space-8);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.form-check-input {
  min-width: 16px;
  min-height: 16px;
  margin-top: 0;
  margin-left: -15px !important;
  background-color: var(--form-check-radio-bg);
  border: 1px solid var(--form-check-radio-border);

  &[type=checkbox]{
    border-radius: $br-xs;
  }

  &:checked {
    background-color: var(--accent-100);
    border-color: var(--accent-200);
  }

  &:checked:disabled {
    background-color: var(--text-neutral);
    border-color: var(--text-neutral);
    cursor: not-allowed;
  }

  &:focus,
  &:hover {
    box-shadow: var(--shadow-outline) !important;
    cursor: pointer;
  }
}

.icon{
  margin-right: var(--space-4);
  width: 14px;
  color: var(--text-neutral);
  font-size: var(--fs-14);
  display: inline-block;
  vertical-align: middle;
  line-height: 20px;
  text-align: center;
}
.color{
  width: 14px;
  height: 14px;
  border-radius: $br-xs;
  display: inline-block;
  vertical-align: middle;
  margin-right: var(--space-4);
  &.palette-purple-light{
    background-color: var(--palette-purple-color-light);
  }
}
</style>
